<!--乙肝两对半检查、抗HCV、抗HIV-->
<script setup>
import { computed, reactive,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import check from "./check.vue";
import upload from "@/components/upload1.vue"
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen
//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0


// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
// hbv_dna 的数量
const arrs = [
  '10^1',
  '10^2',
  '10^3',
  '10^4',
  '10^5',
  '10^6',
  '10^7',
  '10^8',
];
</script>
<template>
  <template v-if="crfFields">
    <div style="display: flex;">
      <h2>乙肝两对半检查、抗HCV、抗HIV</h2>
      <upload :type="props.type" :data="model" name="yghcvhiv"></upload>
      <check :period="props.type" text="乙肝两对半检查、抗HCV、抗HIV" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    
    <el-form-item label="乙肝两对半检查是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['乙肝两对半检查是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['乙肝两对半检查是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增乙肝两对半检查、抗HCV、抗HIV':'乙肝两对半检查、抗HCV、抗HIV'"  v-if="crfFields && notScreen" class="redStar">
            <el-radio-group v-if="notScreen" v-model="crfFields['是否新增乙肝两对半检查']">
              <el-radio label="是" prop="是"></el-radio>
              <el-radio label="否" prop="否"></el-radio>
            </el-radio-group>

        </el-form-item>
        
        <template v-if="crfFields['是否新增乙肝两对半检查'] == '是' || !notScreen">
            <el-form-item label="乙肝表面抗原" class="redStar" :prop="itemProp(`乙肝表面抗原`)" :rules="crfStore.radioRules(`乙肝表面抗原`)">
              <el-radio-group v-model="crfFields['乙肝表面抗原']" >
                <el-radio label="阳性" prop="阳性"></el-radio>
                <el-radio label="阴性" prop="阴性"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>

              </el-radio-group>
              <!-- <el-input v-model="crfFields['乙肝表面抗原']" autocomplete="off"></el-input> -->
            </el-form-item>

            <el-form-item label="HBV-DNA（IU/ml）" v-if="crfFields['乙肝表面抗原'] == '阳性'" class="redStar">
              <div class="box">
                <el-select v-model="crfFields['HBV-DNA_符号']" class="m-21">
                  <el-option label="无" value="无"/>
                  <el-option label="<" value="小于"/>
                  <el-option label="=" value="等于"/>
                </el-select>
                <el-input v-model="crfFields['HBV-DNA']" autocomplete="off">
                  <!-- // <template #append>IU/ml</template> -->
                </el-input>
              <span class="chenghao">x</span>
                <el-select v-model="crfFields['HBV-DNA_数量']" class="m-2" placeholder="请选择">
                  <el-option
                    v-for="item in arrs"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
                <span class="danwei">IU/ml</span>
              </div>
              
            </el-form-item>

            <!-- <el-form-item label="抗HBs抗体" :prop="itemProp('抗HBs抗体')"
                          :rules="crfStore.floatNumberRules('抗HBs抗体',true)">
              <el-input v-model="crfFields['抗HBs抗体']" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="乙肝E抗原" :prop="itemProp('乙肝E抗原')"
                          :rules="crfStore.floatNumberRules('乙肝E抗原',true)">
              <el-input v-model="crfFields['乙肝E抗原']" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="抗HBe抗体" :prop="itemProp('抗HBe抗体')"
                          :rules="crfStore.floatNumberRules('抗HBe抗体',true)">
              <el-input v-model="crfFields['抗HBe抗体']" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="乙肝核心抗体IgM" :prop="itemProp('乙肝核心抗体IgM')"
                          :rules="crfStore.floatNumberRules('乙肝核心抗体IgM',true)">
              <el-input v-model="crfFields['乙肝核心抗体IgM']" autocomplete="off"></el-input>
            </el-form-item> -->

            <el-form-item label="抗丙型肝炎抗体" class="redStar" :prop="itemProp(`抗丙型肝炎抗体`)" :rules="crfStore.radioRules(`抗丙型肝炎抗体`)">
              <el-radio-group v-model="crfFields['抗丙型肝炎抗体']">
                <el-radio label="阳性" prop="阳性"></el-radio>
                <el-radio label="阴性" prop="阴性"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="crfFields['抗丙型肝炎抗体'] == '阳性'" label="HCV-RNA" class="redStar">
              <el-radio-group v-model="crfFields['HCV-RNA']">
                <el-radio label="阳性" prop="阳性"></el-radio>
                <el-radio label="阴性" prop="阴性"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="抗HIV" class="redStar" :prop="itemProp(`抗HIV`)" :rules="crfStore.radioRules(`抗HIV`)">
              <el-radio-group v-model="crfFields['抗HIV']">
                <el-radio label="阳性" prop="阳性"></el-radio>
                <el-radio label="阴性" prop="阴性"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>
        </template>
      </template>
  </template>
</template>

<style lang="scss" scoped>
  .box{
    ::v-deep .el-select{
      .el-input__wrapper{
        width:60px;
      }
      margin-left:5px;
    }
    display:flex;
    .chenghao{
        margin-left: 5px;
        border: 1px solid rgb(220, 223, 230);
        box-sizing: border-box;
        text-align: center;
        border-radius: 4px;
        width:50px;
        height: 32px;
      }
      .danwei{
        border-radius: 4px;
        box-sizing: border-box;
        text-align: center;
        width: 200px;
        background-color: rgb(245, 247, 250);
        border:1px solid rgb(220, 223, 230);
        color:rgb(144, 147, 153);
        height: 32px;

      }
  }
  .m-21{
    width: 60px;
  }
  
</style>